import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { MuiButton } from '../../../../../components'

export const ChartContainer = styled(Box)(`
    width: 100%; 
    border: 1px solid #f0f0f0;
    background: white; 
    // overflow-x: auto;
    overflow-x: hidden;
    padding-right: 20px;
    border-radius: 10px;
    margin: 10px 0;
    position:relative;

    & svg g path[class="domain"]{
        display: none;
    }

    .next, .prev{
        position: absolute;
        top: calc(50% - 40px);
        cursor: pointer;
        zIndex: 10;
        transition: opacity 0.3s ease;
    }

    .next{
        right: 0;
    }
    .prev{
        left: 0;
    }
`)

export const NumberLhs = styled(Box)(`
    position: absolute;
    background: #fff;
    top: 0;
    left: 0;

    width: 50px;
    padding: 10px 5px 10px 27px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    height: 505px;
    border-radius: 8px;

    span {
        height: 73px;
        width: 100%;
        display: block;
        text-align: right;
    }
    span:last-child {
        height: 20px;
    }
    
    span:nth-child(1), span:nth-child(2), span:nth-child(3) { color: #00B050; }
    span:nth-child(4) { color: #7C868F; }
    span:nth-child(5), span:nth-child(6), span:nth-child(7) { color: #EE2534; }

`)

export const ArrowButtons = styled(MuiButton)(`
  position : absolute;
  display : flex !important;
  padding : 25px 8px !important;
  min-width : unset;
  z-index : 5;
  top : 60%;
  background : rgba(204, 204, 204, 1);
  svg {
    fill : rgba(104, 104, 103, 1);
  }
  
  &:focus {  
    background : rgba(204, 204, 204, 1);
    svg {
      fill : rgba(104, 104, 103, 1);
    }
  }
  
  &:hover {
    background : rgba(69, 69, 69, 1);
    svg {
      fill : rgba(255, 255, 255, 1);
    }
  }
  
  &:active {
    background : rgba(42, 42, 41, 1);
    svg {
      fill : rgba(255, 255, 255, 1) !important;
    }
  }
    
  &.slick-disabled {
    background : rgba(246, 246, 245, 1);
    svg {
      fill : rgba(202, 208, 213, 1);
    }
  }

  &:before {
    content : '';
  }

  &.slick-prev {
    left : 0
  }

  &.slick-next {
    right : 0px;
  } 
`)


